import { EVENT_HANDLER_TYPES } from '../constants';
import { EventHandler } from './EventHandler';

let lastSeen: number;
let interval: number;

export class ScriptInterruption {

  public static run(ms = 1000): void {
    if (!interval) {
      lastSeen = Date.now();
      interval = window.setInterval(() => {
        const now = Date.now();
        const calculated = (lastSeen + 10000); // ms * 2

        if (now > calculated) {
          EventHandler.trigger(EVENT_HANDLER_TYPES.SCRIPT_INTERRUPTION, (now - calculated));
        }

        lastSeen = Date.now();
      }, ms);
    }
  }

  public static stop(): void {
    if (interval) {
      window.clearInterval(interval);
      interval = null;
    }
  }

}
